<template>
    <div>
        <b-card>
          <h3>General Details</h3>
          <br/>
          <b-row>
            <b-col></b-col>
            <b-col align="left">Created By</b-col><b-col>{{ Values.General.CreatedBy }}</b-col>
          <b-col></b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col align="left">Created On</b-col><b-col>{{Values.General.CreatedOn}}</b-col>
            <b-col></b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col align="left">Location</b-col><b-col>{{Values.General.Location}}</b-col>
            <b-col></b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col align="left">Responsible Department</b-col><b-col><b-form-input v-model="Values.General.ResponsibleDept"></b-form-input></b-col>
            <b-col></b-col>
          </b-row>
          <hr/>
          <!-- <b-row><b-col><h3>Escalation Contact</h3></b-col></b-row>
          <b-row>
            <b-col></b-col>
            <b-col align="left">Escalation Name</b-col><b-col><b-form-input v-model="Values.General.EscalationName"></b-form-input></b-col>
            <b-col></b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col align="left">Escalation Email Address</b-col><b-col><b-form-input v-model="Values.General.EscalationEmail"></b-form-input></b-col>
            <b-col></b-col>
          </b-row>
          <b-row>
            <b-col></b-col>
            <b-col align="left">Is Escalation contact a Seraph User</b-col><b-col><b-form-select v-model="Values.General.EscalationSeraph" :options="options"></b-form-select></b-col>
            <b-col></b-col>
          </b-row>                       -->
          <b-row><b-col><b-button variant="outline-success" v-if="stepComplete == false" v-on:click="CompletePage()">Page Complete</b-button></b-col></b-row>

        </b-card>
    </div>
</template>

<script>
    export default {
      props:['DataPass','Type','ID'],
      data() {
      return {
        selectedlocation: localStorage.getItem("CurrentLocation"),
        CurrentName: localStorage.getItem("fullname"),
        stepComplete: false,
        // options: [{ value: null, text: 'Please select an option' },
        //   { value: 'true', text: 'True' },
        //   { value: 'false', text: 'False' }],
        //   ValidMail: false,
        Values: {
          General: {
                        CreatedBy: "",
                        CreatedOn: "",
                        Location: "",
                        ResponsibleDept: "",
                        // EscalationName: "",
                        // EscalationEmail: "",
                        // EscalationSeraph: null
                    },
        }
    }
    
    },
    computed: {},
    components: {},
    mounted(){
      if (this.Type == 'Modify'){
      this.Values.General.CreatedBy = this.DataPass.General.CreatedBy
      this.Values.General.CreatedOn = this.DataPass.General.CreatedOn
      this.Values.General.Location = this.DataPass.General.Location
      this.Values.General.ResponsibleDept = this.DataPass.General.ResponsibleDept
      // this.Values.General.EscalationName = this.DataPass.General.EscalationName
      // this.Values.General.EscalationEmail = this.DataPass.General.EscalationEmail
      // this.Values.General.EscalationSeraph = this.DataPass.General.EscalationSeraph
      }
      else{
        let current = new Date();
        this.TodayDate =
        current.getFullYear() +
        "-" +
        (current.getMonth() + 1) +
        "-" +
        current.getDate();
        this.Values.General.CreatedBy = this.CurrentName
        this.Values.General.CreatedOn = this.TodayDate
        this.Values.General.Location = this.selectedlocation

      }

       
    },
    methods:{
      CompletePage(){
        this.stepComplete = false
        if(this.Values.General.CreatedBy == "" ||
          this.Values.General.CreatedOn == "" ||
          this.Values.General.Location == "" ||
          this.Values.General.ResponsibleDept == ""){
          // this.Values.General.EscalationName == "" ||
          // this.Values.General.EscalationEmail == "" ||
          // this.Values.General.EscalationSeraph == null){
          alert('All fields on this page must be completed prior to moving on')
        } else{
          this.$emit("PageComplete",1,this.Values);
          this.stepComplete = true;
        }

       
      },
      // emailIsValid(email) {
      //   this.ValidMail = /\S+@\S+\.\S+/.test(email);
      //   return this.ValidMail
      // },
    },

    }
</script>

<style>

</style>